import { post, get, deletee, put } from '.';
import { AxiosPromise } from 'axios';

import { getAuth } from './localStorage';

export type IgetPartParams = {
  offset?: number;
  search?: string;
  limit?: number;
};

export const getAllKeyWords = (params: IgetPartParams): AxiosPromise<any> => {
  const user = getAuth().user;
  if (!user) {
    return Promise.reject();
  }
  return get({
    subUrl: '/lang/',
    params: { ...params }
  });
};

export type IAddNewKeyword = {
  id?: string;
  default: string;
  ru?: string;
  zh?: string;
  ja?: string;
  ar?: string;
};

export const addNewKeyWord = (data: IAddNewKeyword): AxiosPromise<any> => {
  const user = getAuth().user;
  if (!user) {
    return Promise.reject();
  }
  return post({
    subUrl: '/lang',
    data: data
  });
};

export const updateKeyWord = (data: IAddNewKeyword): AxiosPromise<any> => {
  const user = getAuth().user;
  if (!user) {
    return Promise.reject();
  }
  return put({
    subUrl: '/lang',
    data: data
  });
};

export const deleteKeyWord = (data: string): AxiosPromise<any> => {
  return deletee({
    subUrl: '/lang',
    params: { id: data }
  });
};

export type getPartData = {
  id: string;
};
